const sortOptionsByType = {
    members: [
        {
            id: 1,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
        {
            id: 2,
            optionLabel: 'First Name',
            selectedLabel: 'Sort By: First Name',
            indexSuffix: '_first_name_virtual',
            queryParam: 'sort_by_first_name',
        },
        {
            id: 3,
            optionLabel: 'Last Name',
            selectedLabel: 'Sort By: Last Name',
            indexSuffix: '_last_name_virtual',
            queryParam: 'sort_by_last_name',
        },
        {
            id: 4,
            optionLabel: 'Company',
            selectedLabel: 'Sort By: Company',
            indexSuffix: '_company_virtual',
            queryParam: 'sort_by_company',
        },
        {
            id: 5,
            optionLabel: 'Newest Members',
            selectedLabel: 'Sort By: Newest Members',
            indexSuffix: '_recently_joined_virtual',
            queryParam: 'sort_by_created_at',
        },
    ],
    companies: [
        {
            id: 10,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
        {
            id: 11,
            optionLabel: 'Company Name',
            selectedLabel: 'Sort By: Company Name',
            indexSuffix: '_company_name_virtual',
            queryParam: 'sort_by_company',
        },
        {
            id: 12,
            optionLabel: 'Newest Companies',
            selectedLabel: 'Sort By: Newest Companies',
            indexSuffix: '_recently_joined_virtual',
            queryParam: 'sort_by_created_at',
        },
    ],
    articles: [
        {
            id: 20,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
        {
            id: 21,
            optionLabel: 'Latest',
            selectedLabel: 'Sort By: Latest',
            indexSuffix: '_created_at_desc_virtual',
            queryParam: 'sort_by_created_at',
        },
    ],
    publications: [
        {
            id: 30,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
        {
            id: 31,
            optionLabel: 'Recently Added',
            selectedLabel: 'Sort By: Recently Added',
            indexSuffix: '_created_at_desc',
            queryParam: 'sort_by_recently_added',
        },
        {
            id: 32,
            optionLabel: 'Title (A-Z)',
            selectedLabel: 'Sort By: Title(A-Z)',
            indexSuffix: '_title_asc',
            queryParam: 'sort_by_title',
        },
        {
            id: 33,
            optionLabel: 'Title (Z-A)',
            selectedLabel: 'Sort By: Title(Z-A)',
            indexSuffix: '_title_desc',
            queryParam: 'sort_by_title_reversed',
        },
    ],
    events: [
        {
            id: 40,
            optionLabel: 'Date',
            selectedLabel: 'Sort By: Date',
            indexSuffix: '',
            queryParam: 'sort_by_start_time',
            default: true,
        },
        {
            id: 41,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '_best_match',
            queryParam: 'sort_by_best_match',
        },
        {
            id: 42,
            optionLabel: 'Title',
            selectedLabel: 'Sort By: Title',
            indexSuffix: '_title_asc',
            queryParam: 'sort_by_title',
        },
    ],
    everything: [
        {
            id: 50,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
        {
            id: 51,
            optionLabel: 'Date',
            selectedLabel: 'Sort By: Date',
            indexSuffix: '_created_at_desc_virtual',
            queryParam: 'sort_by_created_at',
        },
        {
            id: 52,
            optionLabel: 'Title (A-Z)',
            selectedLabel: 'Sort By: Title',
            indexSuffix: '_title_asc_virtual',
            queryParam: 'sort_by_title',
        },
    ],
    event_sessions: [
        {
            id: 110,
            optionLabel: 'Date',
            selectedLabel: 'Sort By: Date',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
    ],
    properties: [
        {
            id: 60,
            optionLabel: 'Recent',
            selectedLabel: 'Sort By: Recent',
            indexSuffix: '_activated_at_desc',
            queryParam: 'sort_by_recent',
            default: true,
        },
        {
            id: 61,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: 'sort_by_best_match',
        },
        {
            id: 62,
            optionLabel: 'Name',
            selectedLabel: 'Sort By: Name',
            indexSuffix: '_title_asc',
            queryParam: 'sort_by_title',
        },
        {
            id: 63,
            optionLabel: 'Expiring Soon',
            selectedLabel: 'Sort By: Expiring Soon',
            indexSuffix: '_expires_at_asc',
            queryParam: 'sort_by_expiring_soon',
        },
    ],
    listed_properties: [
        {
            id: 70,
            optionLabel: 'Recent',
            selectedLabel: 'Sort By: Recent',
            indexSuffix: '_activated_at_desc',
            queryParam: 'sort_by_recent',
            default: true,
        },
        {
            id: 71,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: 'sort_by_best_match',
        },
        {
            id: 72,
            optionLabel: 'Name',
            selectedLabel: 'Sort By: Name',
            indexSuffix: '_title_asc',
            queryParam: 'sort_by_title',
        },
        {
            id: 73,
            optionLabel: 'Expiring Soon',
            selectedLabel: 'Sort By: Expiring Soon',
            indexSuffix: '_expires_at_desc',
            queryParam: 'sort_by_expiring_soon',
        },
    ],
    saved_searchable_members: [
        {
            id: 90,
            optionLabel: 'Recent Matches',
            selectedLabel: 'Sort By: Recent Matches',
            indexSuffix: '_search_created_desc',
            queryParam: 'sort_by_recent',
            default: true,
        },
        {
            id: 91,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
        },
        {
            id: 92,
            optionLabel: 'First Name',
            selectedLabel: 'Sort By: First Name',
            indexSuffix: '_first_name_virtual',
            queryParam: 'sort_by_first_name',
        },
        {
            id: 93,
            optionLabel: 'Last Name',
            selectedLabel: 'Sort By: Last Name',
            indexSuffix: '_last_name_virtual',
            queryParam: 'sort_by_last_name',
        },
        {
            id: 94,
            optionLabel: 'Company',
            selectedLabel: 'Sort By: Company',
            indexSuffix: '_company_virtual',
            queryParam: 'sort_by_company',
        },
    ],
    member_events: [
        {
            id: 100,
            optionLabel: 'Best Match',
            selectedLabel: 'Sort By: Best Match',
            indexSuffix: '',
            queryParam: '',
            default: true,
        },
        {
            id: 101,
            optionLabel: 'First Name',
            selectedLabel: 'Sort By: First Name',
            indexSuffix: '_sort_first_name_asc',
            queryParam: 'sort_by_first_name',
        },
        {
            id: 102,
            optionLabel: 'Last Name',
            selectedLabel: 'Sort By: Last Name',
            indexSuffix: '_sort_last_name_asc',
            queryParam: 'sort_by_last_name',
        },
        {
            id: 103,
            optionLabel: 'Company',
            selectedLabel: 'Sort By: Company',
            indexSuffix: '_sort_company_asc',
            queryParam: 'sort_by_company',
        },
        {
            id: 104,
            optionLabel: 'Newest Members',
            selectedLabel: 'Sort By: Newest Members',
            indexSuffix: '_sort_created_at_desc',
            queryParam: 'sort_by_created_at',
        },
        {
            id: 105,
            optionLabel: 'Latest Attendees',
            selectedLabel: 'Sort By: Latest Attendees',
            indexSuffix: '_sort_registered_at_desc',
            queryParam: 'sort_by_registered_at',
        },
    ],
};

export { sortOptionsByType };
